import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DriverRefreshService {
    private readonly homeRefresh$ = new Subject<void>();
    private readonly queueRefresh$ = new Subject<void>();
    private readonly profileRefresh$ = new Subject<void>();

    readonly onHomeRefresh = this.homeRefresh$.asObservable();
    readonly onQueueRefresh = this.queueRefresh$.asObservable();
    readonly onProfileRefresh = this.profileRefresh$.asObservable();

    refreshHome(): void {
        this.homeRefresh$.next();
    }

    refreshQueue(): void {
        this.queueRefresh$.next();
    }

    refreshProfile(): void {
        this.profileRefresh$.next();
    }

    refreshAll(): void {
        this.homeRefresh$.next();
        this.queueRefresh$.next();
        this.profileRefresh$.next();
    }
}
